import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { application_module_path, application_overview_path, project_overview_path } from '@ui/routes';
/**
 * Generate url searchParams string from the url query params.
 *
 * @param query Url params query
 * @returns Url searchParams
 */ const queryString = function() {
    let query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const params = [];
    for(const key in query){
        const currentItem = query[key];
        const paramName = encodeURIComponent(key);
        if (Array.isArray(currentItem)) {
            currentItem.forEach((param)=>params.push("".concat(paramName, "=").concat(encodeURIComponent(param))));
        } else if (currentItem !== undefined) {
            params.push("".concat(paramName, "=").concat(encodeURIComponent(currentItem)));
        }
    }
    return '?' + params.join('&');
};
export const ProjectLink = (param)=>{
    let { organization, project, children, query } = param;
    const url = project_overview_path({
        organization: {
            name: organization !== null && organization !== void 0 ? organization : ''
        },
        project: {
            name: project !== null && project !== void 0 ? project : ''
        },
        query: queryString(query)
    });
    return /*#__PURE__*/ _jsx(Link, {
        to: url,
        className: "no-underline hover:underline",
        children: children
    });
};
export const ApplicationLink = (param)=>{
    let { organization, project, application, children, query, versionId } = param;
    const url = application_overview_path({
        organization: {
            name: organization !== null && organization !== void 0 ? organization : ''
        },
        project: {
            name: project !== null && project !== void 0 ? project : ''
        },
        application: {
            name: application !== null && application !== void 0 ? application : ''
        },
        versionId,
        query: queryString(query)
    });
    return /*#__PURE__*/ _jsx(Link, {
        to: url,
        className: "text-base no-underline hover:underline",
        children: children
    });
};
export const ModuleLink = (param)=>{
    let { organization, project, application, module, children, query, versionId } = param;
    const url = application_module_path({
        organization: {
            name: organization !== null && organization !== void 0 ? organization : ''
        },
        project: {
            name: project !== null && project !== void 0 ? project : ''
        },
        application: {
            name: application !== null && application !== void 0 ? application : ''
        },
        module,
        versionId,
        query: queryString(query)
    });
    return /*#__PURE__*/ _jsx(Link, {
        to: url,
        className: "no-underline hover:underline",
        children: children
    });
};
